<template>
    <!-- 人体成分 -->
    <div style="width: 611px;">
        <div class="centent-comment-title-div">
            <div class="centent-comment-title">
                人体成分概览
            </div>
            <div class="centent-comment-title" style="font-size: 13px;color: #333333;margin-left: 5px;"> Overview of
                Body Composition</div>
        </div>
        <!-- 表格 -->
        <div class="tabel-box" style="margin-top: 4px;">
            <div style="width: 112px; text-align: left; ">
                <div class="left-item"></div>
                <div class=" line-white"></div>
                <div class="left-item ">&nbsp;&nbsp;体重&nbsp;<span class="unit-span" v-if="isBodyDataNotEmpty()">({{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].unit : "" }})</span></div>
                <div class="line-white"></div>
                <div class="left-item">&nbsp;&nbsp;去脂体重&nbsp;<span class="unit-span" v-if="isBodyDataNotEmpty()">({{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].unit : "" }})</span></div>
                <div class="line-white"></div>
                <div class="left-item">&nbsp;&nbsp;肌肉量&nbsp;<span class="unit-span" v-if="isBodyDataNotEmpty()">({{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].unit : "" }})</span></div>
                <div class="line-white"></div>
                <div class="left-item">&nbsp;&nbsp;总水分&nbsp;<span class="unit-span" v-if="isBodyDataNotEmpty()">({{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].unit : "" }})</span></div>
                <div class="line-white"></div>
            </div>
            <!-- 第二列 测量值-->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">测量值</div>
                <div class="line-white"></div>
                <div class="left-item-nomal isvalue">
                    <span class="font-size-green-bold">{{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].value : "" }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[0].scope : "" }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal isvalue">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyComposition[2].value : ""
                        }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[2].scope : ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[4].value : "" }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[4].scope : ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{
                    isBodyDataNotEmpty() ? bodyData.bodyComposition[6].value : "" }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[6].scope : ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
            </div>

            <!-- 第三列 体脂肪 -->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">体脂肪</div>
                <div class="line-white"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyComposition[1].value : ""
                        }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[1].scope : ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal"> </div>
                <div class="line-green"></div>
                <div class="left-item-nomal"></div>
                <div class="line-green"></div>
                <div class="left-item-nomal"> </div>
                <div class="line-green"></div>
            </div>
            <!-- 第四列 无机盐-->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">无机盐</div>
                <div class="line-white"></div>
                <div class="left-item-nomal"> </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyComposition[3].value : ""
                        }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[3].scope :
                    ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal"></div>
                <div class="line-green"></div>
                <div class="left-item-nomal"></div>
                <div class="line-green"></div>
            </div>
            <!-- 第五列 蛋白质-->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">蛋白质</div>
                <div class="line-white"></div>
                <div class="left-item-nomal"> </div>
                <div class="line-green"></div>
                <div class="left-item-nomal"></div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ?
                    bodyData.bodyComposition[5].value : "" }}</span>
                    <span class="font-size-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                        bodyData.bodyComposition[5].scope : ""
                        }}]</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal"></div>
                <div class="line-green"></div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        bodyData: {
            type: Object,
            required: true
        }
    },
    methods: {
        isBodyDataNotEmpty() {
            return this.bodyData && Object.keys(this.bodyData).length > 0;
        }
    }

}

</script>

<style scoped>
/* 内容局域  头部文字的公共样式*/
.centent-comment-title-div {
    display: flex;
    flex-direction: row;
}

.centent-comment-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 19px;
    color: #000000;
    line-height: 26px;
    text-align: left;
    font-style: normal;
}

/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: row;
    border: 1px solid #F0F9F6;
}

/* 第一列左边tilte */
.left-item {
    font-size: 13px;
    color: #333333;
    font-weight: bold;
    height: 34px;
    line-height: 34px;
    border-left: 1px solid #F0F9F6;

}

/* item 白色块 */
.left-item-nomal {
    background: #ffffff;
    height: 34px;
    line-height: 34px;
    border-left: 1px solid #F0F9F6;
}

/* 白色下划线 */
.line-white {
    height: 1px;
    background: #F0F9F6;
}

/* 绿色下划线 */
.line-green {
    background: #F0F9F6;
    height: 1px;
}

/* 黑色不加粗 */
.font-size-nomal {
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    margin-left: 4px;
}

/* 黑色不加粗 */
.font-size-bold {
    font-weight: bold;
    font-size: 13px;
    color: #333333;
}

/*绿色加粗  */
.font-size-green-bold {
    font-weight: 500;
    font-size: 13px;
    color: #333333;
}

.mr {
    margin-left: 1px;
}

.unit-span {
    font-weight: 500;
    font-size: 11px;
    color: #333333;
    line-height: 16px;
}
</style>